import React from 'react';
import styled from 'styled-components';

import { HeaderContainer, HeaderMixin } from '../../shared/styles';
import { NameColumn } from './styles';

const NameColumnHeader = styled(NameColumn)`
  ${HeaderMixin}
`;

export default function Header() {
  return (
    <HeaderContainer>
      <NameColumnHeader>Name</NameColumnHeader>
    </HeaderContainer>
  );
}
